import httpClient from '@/httpClient'
import type { ApiResponse } from '@/types/api.types'
import type {
  ICalendarEntryApi,
  IFetchCalendarByDatesPayload,
} from '@/models/interfaces'
import { handleError } from '@/utils/error.utils'

const BASE_URL = '/web/api/Calendar'

// todo move to calendar types

export type GetEntriesApiResponse = {
  events: ICalendarEntryApi[];
};

// todo rework for ai suggested events

export const getCalendarEntriesForRange = async (
  payload: IFetchCalendarByDatesPayload
): Promise<ICalendarEntryApi[]> => {
  const _endpoint = `${BASE_URL}/GetEntries?StartTimeInUtc=${payload.startDate}&EndTimeInUtc=${payload.endDate}`

  try {
    const _response =
      await httpClient.get<ApiResponse<GetEntriesApiResponse>>(_endpoint)

    const _raw = _response.data.value?.events ?? [];

    return _raw;
  } catch (error) {
    handleError({
      error: error,
      action: 'GetEntries',
    })

    //handle the error like usual, like logging to Raygun, then throw the
    //error for the caller to optionally handle it with its own logic
    throw error
  }
}
